import api from "../lib/axios";

const BASE_URL = "/Employee";

export const employeeService = {
  getAll: async (params) => {
    const response = await api.get(`${BASE_URL}`, { params });
    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await api.get(`${BASE_URL}/search`, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  },
  changeStatus: async (id, isActive) => {
    const response = await api.put(`${BASE_URL}/change-status/${id}`, { isActive });
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
  getLocationHistory: async (id, take = 200) => {
    const response = await api.get(`${BASE_URL}/${id}/location-history`, { params: { take } });
    return response.data;
  },
};
